module.exports = __webpack_public_path__ + "img/1.b34275a4.png";